// File: src/components/ConnectShopifyPage.jsx

import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Page, Card, Banner, Spinner } from '@shopify/polaris';

export default function ConnectShopifyPage() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const BACKEND = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'https://api.baobrain.com';
  console.log(
    `[ConnectShopifyPage] rendered — URL: ${location.pathname}${location.search}`
  );
  // 1) Recover the shop URL (passed via state, sessionStorage, or query)
  const site = useMemo(() => {
    // from navigate('/connect-shopify', { state: { site } })
    if (location.state?.site) {
      sessionStorage.setItem('pendingShopifySite', JSON.stringify(location.state.site));
      return location.state.site;
    }
    // from a prior sessionStorage write
    const pending = sessionStorage.getItem('pendingShopifySite');
    if (pending) {
      return JSON.parse(pending);
    }
    // fallback: query param ?shop=...
    const shop = new URLSearchParams(location.search).get('shop');
    if (shop) {
      const obj = { url: shop };
      sessionStorage.setItem('pendingShopifySite', JSON.stringify(obj));
      return obj;
    }
    return undefined;
  }, [location.state, location.search]);

  // 2) If we still don't know which shop, bounce back to your sites list
  useEffect(() => {
    if (!site) {
      navigate('/sites', { replace: true });
    }
  }, [site, navigate]);

  // 3) Build the pure hostname ("mystore.myshopify.com")
  const shopDomain = useMemo(() => {
    if (!site) return '';
    try {
      return new URL(site.url).hostname;
    } catch {
      return site.url;
    }
  }, [site]);

  // 4) As soon as we mount *and* have a shopDomain, do the App‐Bridge handshake
  useEffect(() => {
    if (!shopDomain) return;

    // Store it in case we need it post-redirect
    sessionStorage.setItem('pendingShopifySite', JSON.stringify({ url: shopDomain }));

    // Redirect into your backend's /shopify/connect which then
    // issues the proper OAuth redirect (and never writes to your DB yet).
    // This forces the whole browser tab to navigate, busting out of the iframe.
    // preserve the entire Shopify callback query-string
    const qs = window.location.search;              
    window.top.location.replace( // <--- FIX APPLIED HERE
      `${BACKEND}/shopify/connect${qs}` // Append the full query string
    );
  }, [shopDomain, BACKEND]); 

  // 5) Show a spinner while the browser is redirecting
  return (
    <Page title="Connect Your Shopify Store">
      <Card sectioned>
        <Banner status="info">
          Redirecting you to Shopify for authentication…
        </Banner>
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Spinner size="large" accessibilityLabel="Redirecting to Shopify" />
        </div>
      </Card>
    </Page>
  );
}